import React, { useEffect, useRef, useState } from "react";
import moment from 'moment';
import styles from './Timer.module.css';

const Timer = (props) => {
  const { info, textStyle } = props;
  const [display, setDisplay] = useState('');
  const timerRef = useRef(null);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      const current = moment(new Date());
      const orderTime = moment(new Date(info));
      const dif = Math.abs(current - orderTime);
      const temp = moment.duration(dif);
      const hrs = temp.hours() < 10 ? `0${temp.hours()}` : temp.hours();
      const mins = temp.minutes() < 10 ? `0${temp.minutes()}` : temp.minutes();
      const sec = temp.seconds() < 10 ? `0${temp.seconds()}` : temp.seconds();
      setDisplay(`${hrs}:${mins}:${sec}`);
    }, 1000);

    return () => {
      clearInterval(timerRef.current);
    }
  }, []);

  return (
    <div className={textStyle ? textStyle : styles.headerTimer}>{display}</div>
  );
}

export default Timer;